import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { TableOption } from '../components/TableOption';
import { Button } from '../components/Button';
import { CalendarIcon, MapPinIcon, ClockIcon, InfoIcon } from 'lucide-react';
export const EventDetails = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [selectedTable, setSelectedTable] = useState<string | null>(null);
  // Mock event data
  const event = {
    id: id || '1',
    title: 'Summer Club Night',
    date: 'Saturday, 15 July 2023',
    time: '22:00 - 05:00',
    location: 'Club XYZ, Friedrichstraße 123, 10117 Berlin',
    description: 'Join us for an unforgettable night with the best DJs in town. Experience premium service and exclusive atmosphere.',
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tables: [{
      id: 't1',
      name: 'VIP Table',
      capacity: 6,
      price: 300,
      minimumSpend: 500,
      description: 'Premium table with the best view of the dance floor. Includes bottle service.'
    }, {
      id: 't2',
      name: 'Lounge Area',
      capacity: 8,
      price: 400,
      minimumSpend: 600,
      description: 'Comfortable lounge area with sofas and private service.'
    }, {
      id: 't3',
      name: 'Bar Table',
      capacity: 4,
      price: 150,
      description: 'High table near the bar with dedicated service.'
    }]
  };
  const handleBack = () => {
    navigate(-1);
  };
  const handleContinue = () => {
    if (selectedTable) {
      navigate(`/booking/${id}/${selectedTable}`);
    }
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-272">
      <Header title={event.title} onBack={handleBack} data-id="element-273" />
      <div className="relative" data-id="element-274">
        <div className="h-48 bg-gray-300 bg-center bg-cover" style={{
        backgroundImage: `url(${event.imageUrl})`
      }} data-id="element-275"></div>
        <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-276"></div>
      </div>
      <div className="p-4" data-id="element-277">
        <div className="border border-dashed border-gray-300 rounded-lg p-4 -mt-6 bg-white relative mb-4" data-id="element-278">
          <h1 className="text-xl font-bold text-gray-800 mb-2" data-id="element-279">
            {event.title}
          </h1>
          <div className="flex items-center mb-2 text-gray-700" data-id="element-280">
            <CalendarIcon className="h-4 w-4 mr-2" data-id="element-281" />
            <span data-id="element-282">{event.date}</span>
          </div>
          <div className="flex items-center mb-2 text-gray-700" data-id="element-283">
            <ClockIcon className="h-4 w-4 mr-2" data-id="element-284" />
            <span data-id="element-285">{event.time}</span>
          </div>
          <div className="flex items-center mb-3 text-gray-700" data-id="element-286">
            <MapPinIcon className="h-4 w-4 mr-2" data-id="element-287" />
            <span data-id="element-288">{event.location}</span>
          </div>
          <div className="flex items-start mb-2 text-gray-700" data-id="element-289">
            <InfoIcon className="h-4 w-4 mr-2 mt-1 flex-shrink-0" data-id="element-290" />
            <p className="text-sm" data-id="element-291">{event.description}</p>
          </div>
        </div>
        <h2 className="text-lg font-bold text-gray-800 mb-3" data-id="element-292">
          Available Tables
        </h2>
        {event.tables.map(table => <TableOption key={table.id} {...table} selected={selectedTable === table.id} onSelect={() => setSelectedTable(table.id)} data-id="element-293" />)}
        <Button onClick={handleContinue} disabled={!selectedTable} className="w-full mt-4" data-id="element-294">
          Continue
        </Button>
      </div>
      <Navigation data-id="element-295" />
    </div>;
};